import { Sparkle } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="px-6 font-display text-lg italic text-cacao/70 sm:text-xl">
          {item}
        </span>
        <Sparkle className="h-3.5 w-3.5 text-rosa" strokeWidth={2.5} />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-pink-100 bg-burro/70 py-4"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
